module.exports = __webpack_public_path__ + "static/fg-c586da8f226adf5817f0f05d926e2b29.png";